import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { SwiperComponent, SwiperModule } from 'swiper/angular';

@NgModule({
  declarations: [AppComponent ],
  entryComponents: [],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule,
    SwiperModule,
  AngularFireModule.initializeApp({
    apiKey: 'AIzaSyBm7i3nwvHMjVxrFcKguqeSTQsHLXWrLpM',
    authDomain: 'mesk-care.firebaseapp.com',
    projectId: 'mesk-care',
    storageBucket: 'mesk-care.appspot.com',
    messagingSenderId: '419398762226',
    appId: '1:419398762226:web:40ce11514a1286bcc0da6b',
    measurementId: 'G-T4P72D2N1M'
  }),
  AngularFireAuthModule,
  AngularFirestoreModule,

  ],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],
  bootstrap: [AppComponent],
})
export class AppModule {}
